import React, { useCallback } from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { useField } from 'formik';
import { FileField, CommonFieldProps } from 'components/file-field/file-field';
import { pick } from 'utils/pick';
import { FileRef } from 'types';

type FormItemFileFieldProps = Omit<CommonFieldProps, 'value' | 'onChange'>;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    error: {
      color: theme.palette.error.main,
      fontWeight: 'normal',
      height: '2em',
    },
  })
);

export function FormItemSingleFileField(props: FormItemFileFieldProps) {
  const classes = useStyles();

  type TValue = FileRef | undefined;

  const [field, meta, helpers] = useField<FileRef | undefined>(props.name);

  const value: TValue = field.value;

  const handleChange = useCallback(
    (value: TValue) => {
      helpers.setValue(value);
    },
    [helpers]
  );

  const innerProps = pick(props, 'label', 'name');

  return (
    <>
      <div className={classes.error}>{meta.error}</div>
      <FileField {...innerProps} value={value} onChange={handleChange} />
    </>
  );
}
